var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"px-2",attrs:{"flat":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.tabs[_vm.tab].component,{tag:"component",attrs:{"type":_vm.type},on:{"to-detail":_vm.toDetail,"to-back":_vm.toBack}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }